import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Dashboard from "./AdminportalFolder/Dashboard/Dashboard";
import Sidebar from "./AdminportalFolder/Sidebar";
import Navbar from "./AdminportalFolder/Navbar";
import Vendor from "./AdminportalFolder/Vendor";
import Team from "./AdminportalFolder/UsersFlow/Team.jsx";
import ItemMaster from "./AdminportalFolder/ItemMaster/itemMaster.jsx";
// import VendorCopy from "./AdminportalFolder/VendorScroll.js";
import Client from "./AdminportalFolder/Client";
import InstallationPartner from "./AdminportalFolder/InstallationPartner";
import CampaignTable from "./AdminportalFolder/CampaignTable";
import RfpTable from "./AdminportalFolder/RFP/RfpTable";
import Recce from "./AdminportalFolder/RecceApproval/Recce";
import axios from "axios";
import Map from "./AdminportalFolder/Map";
// import CompanyView from "./AdminportalFolder/CompanyView";
import { Campaign } from "@mui/icons-material";
import JobBatches from "../components/AdminportalFolder/jobBatch/JobBatches";
import CamDashboard from "../components/AdminportalFolder/Campaign/CamDashboard";
import PDITable from "../components/AdminportalFolder/PDI/PDITable";
import PDIEditableTable from "../components/AdminportalFolder/PDI/PDIEditableTable";
import Payments from "../components/AdminportalFolder/Payments/Payment";
// import TestingChip from "./AdminportalFolder/TestingChip";
// import ViewVendorForm from "./AdminportalFolder/ViewVendorForm";
import AdminApprovalTable from "./AdminportalFolder/Campaign/AdminApprovalTable";
// import Dropdown from "./AdminportalFolder/Dropdown.js";
import CostCalculator from "./AdminportalFolder/CostCalculator/index.js";

import MachineFilter from "./AdminportalFolder/MachineFilter/index.js";
// import Mask from "./AdminportalFolder/MaskData/Mask";
import Dropdown from "./AdminportalFolder/Dropdown.js";
import VerifyStoreLocations from "./AdminportalFolder/VerifyStoreLocations/index.js";
import Contractor from "./AdminportalFolder/Contractor/Contractor.main.jsx";
import StoreOTP from "./AdminportalFolder/StoreOTP";
import GenratePurchaseOrder from "./AdminportalFolder/PO/GeneratePurchaseOrder.jsx";
import PurchaseOrderTable from "./AdminportalFolder/PO/PurchaseOrderTable.jsx";
import DeliveryCenters from "./AdminportalFolder/DeliveryCenters/index.js";
import ViewPurchaseOrder from "./AdminportalFolder/PO/ViewPurchaseOrder.jsx";
import AssignDeliveryCenterInEnquiry from "./AdminportalFolder/RFP/DeliveryCenter/AssignDeliveryCenterInEnquiry.jsx";
import AssignDeliveryCenterInCampaign from "./AdminportalFolder/Campaign/DeliveryCenter/AssignDeliveryCenterInCampaign.jsx";
import AssignStores from "./AdminportalFolder/PO/AssignStores.jsx";
import LinkedStores from "./AdminportalFolder/PO/LinkedStores.jsx";
// import MachineFilter from "./AdminportalFolder/MachineFilter/MachineFilter.jsx";
import VendorViewRoute from "./AdminportalFolder/VendorDetails/VendorViewRoute.js";
import PurchaseOrderDocuments from "./AdminportalFolder/VendorDetails/PurchaseOrderDocuments.jsx";
import StoresAssignedToPO from "./AdminportalFolder/VendorDetails/StoresAssignedToPO.jsx";
import InstallationFlag from "./AdminportalFolder/InstallationFlag/InstallationFlag.js";
import AddClient from "./AdminportalFolder/AddClient.js";
import CompanyView from "./AdminportalFolder/CompanyView/index.js";

const AdminPortal = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const [logoutLoading, setLogoutLoading] = useState(false);
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;
  const role = localStorage.getItem("role");

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      // If no token is found, redirect to login
      navigate("/adminportal");
    } else {
      // Verify the token with the backend
      axios
        .get(`${serverURL}/api/auth/protected-route`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUser(response.data.user); // Store user data if needed
        })
        .catch((error) => {
          console.error("Authentication failed", error);
          navigate("/adminportal"); // Redirect to login if the token is invalid
        });
    }
  }, [navigate]);

  if (!user) {
    return null; // Optionally render a loading spinner or similar here
  }

  return (
    <div className="flex">
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex-grow max-w-full">
        <Navbar isOpen={isOpen} setIsOpen={setIsOpen} setLoading={setLoading} />
        <div
          className={` ${isOpen ? `ml-64` : `ml-14`} max-w-full    `}
          style={{
            height: "93vh",
            backgroundColor: "rgb(244, 244, 244)",
          }}
        >
          <Routes>
            {/* Routes for roles -1 : Super Admin */}
            {role === "-1" && (
              <>
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {user && (
                  <Route
                    path="/vendorDetails/:id/purchaseOrder"
                    element={<PurchaseOrderDocuments />}
                  ></Route>
                )}
                {user && (
                  <Route
                    path="/vendorDetails/:id/stores/:purchaseOrderId"
                    element={<StoresAssignedToPO />}
                  ></Route>
                )}
                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && <Route path="enquiry" element={<RfpTable />} />}
                {user && (
                  <Route
                    path="rfp/:id/assign-delivery-center"
                    element={<AssignDeliveryCenterInEnquiry />}
                  />
                )}
                {user && (
                  <Route path="costCalculator" element={<CostCalculator />} />
                )}
                {user && (
                  <Route path="deliveryCenters" element={<DeliveryCenters />} />
                )}
                {user && (
                  <Route
                    path="locationsVerification"
                    element={<VerifyStoreLocations />}
                  />
                )}
                {user && <Route path="RecceApprove" element={<Recce />} />}
                {user && <Route path="map" element={<Map />} />}
                {user && (
                  <Route
                    path="dashboard"
                    element={
                      <Dashboard loading={loading} setLoading={setLoading} />
                    }
                  />
                )}
                {user && (
                  <Route path="/campaign/:id" element={<JobBatches />} />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
                {user && (
                  <Route
                    path="campaign/assign-delivery-center/:id"
                    element={<AssignDeliveryCenterInCampaign />}
                  />
                )}
                {user && <Route path="clientDetails" element={<Client />} />}
                <Route path="/clientDetails/add/*" element={<AddClient />} />
                <Route
                  path="/clientDetails/edit/:organizationId/*"
                  element={<AddClient />}
                />

                <Route
                  path="/clientDetails/view/:organizationId"
                  element={<CompanyView />}
                />
                {user && <Route path="vendorDetails" element={<Vendor />} />}
                {user && <Route path="team" element={<Team />} />}
                {user && <Route path="itemMaster" element={<ItemMaster />} />}
                {/* {user && (
                  <Route path="vendorDetails" element={<VendorCopy />} />
                )} */}
                {user && (
                  <Route
                    path="installation-partner"
                    element={<InstallationPartner />}
                  />
                )}
                {user && (
                  <Route
                    path="installation-Flag"
                    element={<InstallationFlag />}
                  />
                )}
                {user && <Route path="contractor" element={<Contractor />} />}
                {user && <Route path="PDI" element={<PDITable />} />}
                {user && (
                  <Route
                    path="PDIEditableTable"
                    element={<PDIEditableTable />}
                  />
                )}
                {user && (
                  <Route path="machineFilter" element={<MachineFilter />} />
                )}
                {user && <Route path="payments" element={<Payments />} />}
                {user && (
                  <Route
                    path="purchaseOrder"
                    element={<PurchaseOrderTable />}
                  />
                )}
                {user && (
                  <Route path="generatePO" element={<GenratePurchaseOrder />} />
                )}
                {user && (
                  <Route path="viewPO" element={<ViewPurchaseOrder />} />
                )}
                {user && (
                  <Route path="assignStores" element={<AssignStores />} />
                )}
                {user && (
                  <Route path="linkedStores/:poId" element={<LinkedStores />} />
                )}
                {/* {user && <Route path="chip" element={<TestingChip />} />} */}
                {/* {user && <Route path="view" element={<ViewVendorForm />} />} */}
                {/* {user && <Route path="dropdown" element={<Dropdown />} />} */}
              </>
            )}

            {/* Routes for other roles : MT */}
            {role == "2" && (
              <>
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {user && <Route path="vendorDetails" element={<Vendor />} />}
                {/* {user && (
                  <Route path="vendorDetails" element={<VendorCopy />} />
                )} */}
                {user && (
                  <Route
                    path="installation-partner"
                    element={<InstallationPartner />}
                  />
                )}
                {user && (
                  <Route
                    path="locationsVerification"
                    element={<VerifyStoreLocations />}
                  />
                )}
              </>
            )}

            {/* role == 1 : BD */}
            {role == "1" && (
              <>
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {user && <Route path="vendorDetails" element={<Vendor />} />}

                {user && (
                  <Route
                    path="installation-partner"
                    element={<InstallationPartner />}
                  />
                )}
                {user && <Route path="clientDetails" element={<Client />} />}
                <Route path="/clientDetails/add/*" element={<AddClient />} />
                <Route
                  path="/clientDetails/edit/:organizationId/*"
                  element={<AddClient />}
                />

                <Route
                  path="/clientDetails/view/:organizationId"
                  element={<CompanyView />}
                />
                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && <Route path="RecceApprove" element={<Recce />} />}

                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && <Route path="enquiry" element={<RfpTable />} />}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
                {user && (
                  <Route path="/campaign/:id" element={<JobBatches />} />
                )}
                {user && (
                  <Route
                    path="installation-Flag"
                    element={<InstallationFlag />}
                  />
                )}
                {user && (
                  <Route
                    path="locationsVerification"
                    element={<VerifyStoreLocations />}
                  />
                )}
              </>
            )}
            {/* role == 0 : CSM */}
            {role === "0" && (
              <>
                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && <Route path="enquiry" element={<RfpTable />} />}
                {user && <Route path="RecceApprove" element={<Recce />} />}
                {/* {user && <Route path="map" element={<Map />} />} */}
                {user && (
                  <Route path="/campaign/:id" element={<JobBatches />} />
                )}
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {/* {user && <Route path="clientDetails" element={<Client />} />} */}
                {user && <Route path="vendorDetails" element={<Vendor />} />}
                {/* {user && (
                  <Route path="vendorDetails" element={<VendorCopy />} />
                )} */}
                {user && (
                  <Route
                    path="installation-partner"
                    element={<InstallationPartner />}
                  />
                )}
                {user && (
                  <Route path="StoreOTPVerification" element={<StoreOTP />} />
                )}
                {user && (
                  <Route
                    path="PDIEditableTable"
                    element={<PDIEditableTable />}
                  />
                )}
                {user && <Route path="PDI" element={<PDITable />} />}

                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
                {user && (
                  <Route
                    path="installation-Flag"
                    element={<InstallationFlag />}
                  />
                )}
                {/* {user && (
                  <Route
                    path="locationsVerification"
                    element={<VerifyStoreLocations />}
                  />
                )} */}
              </>
            )}

            {/* role == 3 :Purchase */}
            {role === "3" && (
              <>
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {user && <Route path="vendorDetails" element={<Vendor />} />}
                {user && <Route path="enquiry" element={<RfpTable />} />}
                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
                {user && (
                  <Route
                    path="purchaseOrder"
                    element={<PurchaseOrderTable />}
                  />
                )}
                {user && (
                  <Route path="generatePO" element={<GenratePurchaseOrder />} />
                )}
              </>
            )}
            {role === "4" && (
              <>
                {user && (
                  <Route
                    path="/vendorDetails/:id"
                    element={<VendorViewRoute />}
                  />
                )}
                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && <Route path="enquiry" element={<RfpTable />} />}
                {user && <Route path="RecceApprove" element={<Recce />} />}
                {/* {user && <Route path="map" element={<Map />} />} */}
                {user && (
                  <Route path="/campaign/:id" element={<JobBatches />} />
                )}
                {/* {user && <Route path="clientDetails" element={<Client />} />} */}
                {user && <Route path="vendorDetails" element={<Vendor />} />}
                {user && (
                  <Route
                    path="installation-partner"
                    element={<InstallationPartner />}
                  />
                )}
                {user && (
                  <Route
                    path="PDIEditableTable"
                    element={<PDIEditableTable />}
                  />
                )}
                {user && <Route path="PDI" element={<PDITable />} />}

                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
                {user && (
                  <Route
                    path="installation-Flag"
                    element={<InstallationFlag />}
                  />
                )}
              </>
            )}
            {role == "6" && (
              <>
                {user && (
                  <Route
                    path="locationsVerification"
                    element={<VerifyStoreLocations />}
                  />
                )}
              </>
            )}
            {role === "7" && (
              <>
                {user && <Route path="campaign" element={<CampaignTable />} />}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id"
                    element={<CamDashboard />}
                  />
                )}
                {user && (
                  <Route
                    path="/campaign/dashboard/:id/reccejobApproveAdmin"
                    element={<AdminApprovalTable />}
                  />
                )}
              </>
            )}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminPortal;
